const trustItems = [
  {
    icon: "ri-calendar-line",
    value: "33+",
    label: "Years Serving",
    sub: "Riverside & Inland Empire",
  },
  {
    icon: "ri-government-line",
    value: "Municipal",
    label: "Contract Provider",
    sub: "City of Riverside & Moreno Valley",
  },
  {
    icon: "ri-truck-line",
    value: "24/7",
    label: "Rapid Dispatch",
    sub: "365 Days a Year",
  },
  {
    icon: "ri-shield-star-line",
    value: "Licensed",
    label: "& Fully Insured",
    sub: "Law Enforcement Approved",
  },
];

export default function TrustBar() {
  return (
    <section className="bg-[#111113] border-y border-[#2a2a2c]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 divide-x divide-[#2a2a2c]">
          {trustItems.map((item, i) => (
            <div
              key={i}
              className="flex flex-col items-center justify-center py-10 px-6 text-center gap-2"
            >
              <div className="w-10 h-10 flex items-center justify-center mb-1">
                <i className={`${item.icon} text-[#D4AF37] text-2xl`}></i>
              </div>
              <span
                className="text-white font-black text-2xl md:text-3xl"
                style={{ fontFamily: "'Outfit', sans-serif" }}
              >
                {item.value}
              </span>
              <span className="text-white font-semibold text-sm">{item.label}</span>
              <span className="text-[#888] text-xs">{item.sub}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
